import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapChargebacksQueueDataFromServer } from "mappers";
import { chargebacksService } from "services";
import { uiActions } from "store";
import {
	ErrorResponse,
	ChargebacksQueueDto,
	ChargebacksQueue,
	ChargebacksFetchDataParams,
} from "types";

type ServerData = {
	items: ChargebacksQueueDto[];
	count: number;
};

type MappedData = {
	items: ChargebacksQueue[];
	count: number;
};

const useGetChargebacksHistoricalQuery = ({
	tab,
	fetchData,
}: {
	fetchData: ChargebacksFetchDataParams;
	tab: string;
}) => {
	const dispatch = useDispatch();
	const { page, sortBy, filters } = fetchData;
	const queryResult = useQuery(
		["historicalChargebacksData", tab, page, filters, sortBy],
		() =>
			chargebacksService.getHistorical({
				page,
				sortBy,
				filters,
			}),
		{
			select: ({ items, count }: ServerData): MappedData => ({
				items: items?.map(mapChargebacksQueueDataFromServer),
				count,
			}),
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetChargebacksHistoricalQuery;
